import { Injectable } from '@angular/core';
import { DialogService } from '@ngneat/dialog';

@Injectable()
export class MppDialogService extends DialogService {}
